import React from "react";
import { Link, Outlet } from "react-router-dom";
import { Routes } from "../routes/routes";

export const PublicLayout = () => {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg"
        style={{
          background: "#ffffffff",
          borderBottom: "1px solid rgba(0,0,0,.06)",
        }}
      >
        <div className="container">
          <Link
            className="navbar-brand d-flex align-items-center"
            to={Routes.PublicHome.path}
          >
            <img
              src="/img/fixerDashLogo.png"
              alt="Fixer Aviation"
              style={{ height: 90 }}
            />
            <span>Fixer Aviation Management Panel</span>
          </Link>
        </div>
      </nav>

      <div className="container py-4">
        <Outlet />
      </div>
    </>
  );
};
